// extracted by mini-css-extract-plugin
export default {"fr-view":"Student_fr-view__dPSEy","cover":"Student_cover__FZOoN","course-progress":"Student_course-progress__fZnq3","chapters":"Student_chapters__Slt4D"};